import { useEffect, useState } from 'react';
import { ANNOUNCEMENTS_TYPE } from '../constants/ANNOUNCEMENT';

const useAnnouncements = () => {
  const {
    announcementsController: { announcements },
  } = window.Widget;

  const [selectedFilter, setSelectedFilter] = useState<string | null>(ANNOUNCEMENTS_TYPE.ALL);

  useEffect(() => {
    setSelectedFilter(ANNOUNCEMENTS_TYPE.ALL);
  }, [announcements]);

  const setFilter = (name: string) => {
    setSelectedFilter(name);
  };

  return {
    setFilter,
    selectedFilter,
  };
};

export default useAnnouncements;
